module.exports = __webpack_public_path__ + "static/media/bg.f423ca58.png";